export default __webpack_public_path__ + "static/media/Emmanuel-Resume.181c6e5a.pdf";